<ng-container *ngIf="current && total && current < total">
    <div class="description">
        {{ 'filter.loadMoreDescription' | translateSafe: { from: 1, to: current, total: total } }}
    </div>

    <a [href]="href" class="button kk-btn kk-btn_secondary" (click)="onClick($event)">
        <span *ngIf="!pending">{{ 'filter.buttonText.loadMore' | translateSafe }}</span>
        <app-loading-dots *ngIf="pending"></app-loading-dots>
    </a>
</ng-container>
